<template>
  <div class="section__wrapper" :is-mobile="isMobile">
    <div class="section__title">
      {{ asideDataClone.stepData.step1.niche.name }}
    </div>
    <div class="section__card">
      <div class="section__card__photo">
        <img
          v-if="asideDataClone.stepData.step2.coachImageBlob"
          :src="asideDataClone.stepData.step2.coachImageBlob"
        />
        <div v-else>
          <UserIcon />
        </div>
        <div class="section__card__photo__overlay">
          <img class="icon--pencil" src="../../../assets/pencil.svg" @click="editImage" />
        </div>
      </div>
      <div class="section__card__content">
        <div>
          <div
            v-for="(coach, index) in asideData.stepData.step2.coachList"
            :key="index"
            class="section__card__content__header"
          >
            <div class="section__card__content__header__title">
              {{ coach.name }}
            </div>
            <div class="section__card__content__header__icons">
              <div v-if="coach.vk" class="section__card__content__header__icon">
                <a :href="'https://vk.com/' + coach.vk" target="_blank">
                  <VkCoachIcon />
                </a>
              </div>
              <div v-if="coach.telegram" class="section__card__content__header__icon">
                <a :href="'https://t.me/' + coach.telegram" target="_blank">
                  <TelegramCoachIcon />
                </a>
              </div>
            </div>
          </div>
          <div class="section__card__content__description">
            {{ asideData.stepData.step2.coachList.length > 1 ? 'Тренеры' : 'Тренер' }}
            сборной: &laquo;{{ asideData.stepData.step1.name }}&raquo;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import UserIcon from '@/components/Icons/UserIcon';
import TelegramCoachIcon from '@/components/Icons/TelegramCoachIcon';
import VkCoachIcon from '@/components/Icons/VkCoachIcon';

export default {
  components: {
    UserIcon,
    TelegramCoachIcon,
    VkCoachIcon
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    asideData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      asideDataClone: {}
    };
  },
  watch: {
    asideDataClone: {
      deep: true,
      handler() {
        this.$emit('update:asideData', this.asideDataClone);
      }
    }
  },
  created() {
    this.asideDataClone = cloneDeep(this.asideData);
  },
  methods: {
    editImage() {
      this.asideDataClone.step = 2;
    }
  }
};
</script>
